import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService } from '../../services/user.service';
import { User } from '../../dtos/web-user';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(private userService: UserService) {}

	intercept(request: HttpRequest<User>, next: HttpHandler): Observable<HttpEvent<User>> {
		return next.handle(request).pipe(
			catchError((err) => {
				if (err?.status === 401 && !(err.url ?? '').includes('/auth/login')) {
					// auto logout if 401 response returned from api
					this.userService.logout();
					location.reload();
				}
				console.log('ErrorInterceptor caught an error:', err);
        const error = err.error?.Errors?.[0] || err.error?.message || err.error?.Message || err.message || 'Unknown error';
        return throwError(() => error);
			}),
		);
	}
}
